import { useIsFocused } from 'expo-router/react-navigation';

import { Pressable } from '@/components/ui/pressable';
import { View } from '@/components/ui/view';
import { getVideoUrl, VideoPlayer } from '@/components/videoPlayer';
import { ANALYTICS_EVENTS } from '@/constants/analytics';
import { useAbility } from '@/hooks/useAbility';
import { useAbilityGate } from '@/hooks/useAbilityGate';
import { segmentClient } from '@/util/analytics';

export function EmbeddedVideoPlayer({
  aspectRatio,
  autoplay,
  contentLibraryItemId,
  isPublic,
  onFirstPlay,
  videoId,
  videoProvider,
}: {
  aspectRatio?: {
    height: number;
    width: number;
  };
  autoplay?: boolean;
  contentLibraryItemId?: number;
  isPublic?: boolean;
  onFirstPlay?: () => void;
  videoId: string;
  videoProvider: 'YouTube' | 'Vimeo';
}) {
  const canReadContentLibrary = useAbility().can('read', 'ContentLibraryItem');

  const { guard } = useAbilityGate();

  const isFocused = useIsFocused();

  return (
    <View className="relative">
      {isFocused && (
        <VideoPlayer
          aspectRatio={aspectRatio}
          autoplay={autoplay}
          onFirstPlay={() => {
            segmentClient.track(ANALYTICS_EVENTS.CONTENT_LIBRARY_VIDEO_CLICKED, {
              authenticated: canReadContentLibrary,
              contentLibraryItemId,
              embedded: true,
              videoId,
              videoProvider,
              videoUrl: getVideoUrl(videoId, videoProvider),
            });

            onFirstPlay?.();
          }}
          videoId={videoId}
          videoProvider={videoProvider}
        />
      )}
      {!canReadContentLibrary && !isPublic && (
        <Pressable
          className="absolute inset-0"
          onPress={() => {
            guard('read', 'ContentLibraryItem');

            segmentClient.track(ANALYTICS_EVENTS.CONTENT_LIBRARY_VIDEO_CLICKED, {
              authenticated: false,
              contentLibraryItemId,
              embedded: true,
              videoId,
              videoProvider,
              videoUrl: getVideoUrl(videoId, videoProvider),
            });
          }}
        />
      )}
    </View>
  );
}
